import { useEffect } from 'react';
import { usePoResponseError } from '@gov-nx/api';
import { useMessageEvents } from '@gov-nx/core/events';

export const UrlErrorListener = () => {
	const { toastMessageError } = useMessageEvents();
	const { readableFromUrl, defaultErrorMessage } = usePoResponseError();

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const errorParameter = urlParams.get('error');
		if (errorParameter) {
			const message = readableFromUrl(errorParameter);

			toastMessageError(message ?? defaultErrorMessage(), {
				time: 0,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- These dependencies are correct
	}, []);

	return null;
};
